module.exports = __webpack_public_path__ + "static/media/Milex-Gehrung-Pessary-Instructions-for-Use@3x.73d18b35.jpg";